import { MessageBarType } from "@fluentui/react";
import { getUtcNowUnixTimestamp } from "../utils/date-time";
import { EventNotificationService } from "./event-notification";

export enum BwjToastEvents {
  ShowToast = 'BwjToast.Show',
  DismissToast = 'BwjToast.Dismiss',
}

export interface IShowToastArgs {
  id: number,
  type: MessageBarType;
  message: string;
}

class ToastServiceClass {
  /**
   * Display transient message ('toast') on screen
   * @param type Nature of the message
   * @param message Content of the message
   * @param duration Amount of time the message will remain on screen, if not programatically or user dismissed sooner
   * @returns A token identifying the displayed message, which can be used to programmatically dismiss it
   */
  public show(type: MessageBarType, message: string, duration: number = 5000) {
    const id = getUtcNowUnixTimestamp();
    const args: IShowToastArgs = { id, type, message };
    EventNotificationService.safeDispatch(BwjToastEvents.ShowToast, args);

    window.setTimeout(() => {
      EventNotificationService.safeDispatch(BwjToastEvents.DismissToast, id);
    }, duration);

    return id;
  }

  public dismiss(messageId: number) {
    EventNotificationService.safeDispatch(BwjToastEvents.DismissToast, messageId);
  }
}
export const ToastService = new ToastServiceClass();